import React, { useState, useRef, useLayoutEffect, useCallback, useEffect } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import classes from "./index.module.scss"
import TreeMultiSelectNode from "./TreeMultiSelectNode"

const TreeMultiSelect = (props) => {
  const {
    tree,
    onAdd = () => { },
    onRemove = () => { },
    label,
    className,
    values = [],
    disabled = false,
    placeholder,
    error
  } = props

  const [t] = useTranslation()

  const [search, setSearch] = useState("")
  const [showDropdown, setShowDropdown] = useState(false)
  const [selectedNodes, setSelectedNodes] = useState([])
  const [resultTree, setResultTree] = useState(null)

  const wrapperRef = useRef(null)
  const textRef = useRef(null)
  const inputRef = useRef(null)

  const handleClickOutSide =
    useCallback((event) => {
      if (!!wrapperRef.current?.contains(event.target)) return

      setShowDropdown(false)
    }, [])

  const findNode = (tree, name) => {
    if (tree.name.toLowerCase().startsWith(name.toLowerCase())) {
      return ({ ...tree })
    }

    for (let i = 0; i < tree.children.length; i++) {
      const result = findNode(tree.children[i], name)

      if (!!result) return result
    }
  }

  const handleRemoveChip = (node) => {
    const newSelectedNodes =
      selectedNodes
        .filter(selectedNode => selectedNode._id !== node._id)
        .map(newSelectedNode => ({
          _id: newSelectedNode._id,
          name: newSelectedNode.name,
          node: newSelectedNode
        }))

    setSelectedNodes(newSelectedNodes)

    onRemove(node)
  }

  const handleFocus = () => {
    if (!tree) return

    if (disabled) return

    setShowDropdown(true)

    inputRef.current.focus()
  }

  const handleSearch = async (e) => {
    const value = e.target.value

    setSearch(value)

    if (!!value) {
      const resultTree = findNode(tree, value)

      setResultTree(resultTree ? resultTree : {})

      return
    }

    setResultTree(null)
  }

  useLayoutEffect(() => {
    setSelectedNodes([...values])
  }, [values])

  useEffect(() => {
    window.addEventListener("click", handleClickOutSide)

    return () => {
      window.removeEventListener("click", handleClickOutSide)
    }
  }, [])

  useEffect(() => {
    inputRef.current.style.width = search !== ""
      ? `${textRef.current.offsetWidth}px`
      : "5px"

  }, [search])


  return (
    <div className={className}>
      {
        !!label &&
        <label className={classes["label"]}>
          {label}
        </label>
      }
      <div
        ref={wrapperRef}
        className={classes["wrapper"]}
      >
        <div
          onClick={handleFocus}
          className={clsx(
            classes["select-container"],
            error && classes["select-container-error"]
          )}
        >
          <div className={classes["chip-container"]}>
            {selectedNodes.map((selectedNode, index) => (
              <div
                key={index}
                className={classes["chip"]}
              >
                <div
                  onClick={() => handleRemoveChip(selectedNode)}
                  className={classes["remove-chip"]}
                >
                  &times;
                </div>
                <div className={classes["chip-text"]}>
                  {selectedNode.name}
                </div>
              </div>
            ))}
            <div
              ref={textRef}
              className={classes["text"]}
            >
              {search}
            </div>
            <input
              ref={inputRef}
              disabled={disabled}
              value={search}
              onChange={(e) => handleSearch(e)}
            />
          </div>
        </div>
        {
          showDropdown &&
          <div className={classes["dropdown-menu"]}>
            {resultTree
              ?
              resultTree.name
                ?
                <TreeMultiSelectNode
                  key={resultTree._id}
                  tree={resultTree}
                  onAdd={onAdd}
                  onRemove={onRemove}
                  setSearch={setSearch}
                  selectedNodes={selectedNodes}
                  setSelectedNodes={setSelectedNodes}
                  setResultTree={setResultTree}
                />
                :
                <div className={classes["no"]}>
                  {t("هیچ_موردی_یافت_نشد")}
                </div>
              :
              <TreeMultiSelectNode
                key={tree._id}
                tree={tree}
                onAdd={onAdd}
                onRemove={onRemove}
                setSearch={setSearch}
                selectedNodes={selectedNodes}
                setSelectedNodes={setSelectedNodes}
                setResultTree={setResultTree}
              />
            }
          </div>
        }
        {
          selectedNodes.length === 0 && !search &&
          <div
            onClick={handleFocus}
            className={classes["placeholder"]}
          >
            {placeholder}
          </div>
        }
      </div>

      {
        error &&
        <div className={classes["error"]}>
          {error}
        </div>
      }
    </div>
  )
}

export default TreeMultiSelect